export const ANALYTICS_CONSTANTS = {
    PAGE_VARIANT: 'Homepage'
};
